import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';

// Keep realtime's entry point independent of the feature's SDK/query imports.
export const noteKey = (id: string, scope = sessionScope(useAuthStore.getState())) => ['conversation', id, 'notes', scope] as const;
export const billingKey = (id: string, scope = sessionScope(useAuthStore.getState())) => ['conversation-billing', id, scope] as const;
export const contactHistoryKey = (id?: string, scope = sessionScope(useAuthStore.getState())) => ['contact', id ?? null, 'panel-conversations', scope] as const;
export function currentCustomerPanelKey(key: readonly unknown[]) {
  const scope = sessionScope(useAuthStore.getState());
  return key[0] === 'conversation' && key[2] === 'notes' && key[3] === scope ||
    key[0] === 'conversation-billing' && key[2] === scope ||
    key[0] === 'contact' && key[2] === 'panel-conversations' && key[3] === scope;
}
